/**
 * 日時フォーマット定数（YYYY/MM/DD HH:mm）
 */
export const DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm";

/**
 * 日付フォーマット定数（YYYY/MM/DD）
 */
export const DATE_FORMAT = "YYYY/MM/DD";

/**
 * 日本語日時フォーマット定数（YYYY年MM月DD日 HH:mm）
 */
export const JP_DATE_TIME_FORMAT = "YYYY年MM月DD日 HH:mm";

/**
 * 日本語日付フォーマット定数（YYYY年MM月DD日）
 */
export const JP_DATE_FORMAT = "YYYY年MM月DD日";

/**
 * ISO日付フォーマット定数（YYYY-MM-DD）
 */
export const DATE_ISO_FORMAT = "YYYY-MM-DD";

/**
 * 時刻フォーマット定数（HH:mm）
 */
export const TIME_FORMAT = "HH:mm";

/**
 * 空の時間フォーマット定数（HH:00）
 */
export const TIME_EMPTY_HOUR_FORMAT = "HH:00";

/**
 * 時間フォーマット定数（HH）
 */
export const TIME_HOUR_FORMAT = "HH";

/**
 * 分フォーマット定数（mm）
 */
export const TIME_MINUTE_FORMAT = "mm";

/**
 * ISO日時フォーマット定数（YYYY-MM-DD HH:mm:ss）
 */
export const DATETIME_ISO_FORMAT = "YYYY-MM-DD HH:mm:ss";

/**
 * 日本語曜日フォーマット定数（DD ddd）
 */
export const DAY_JP_FORMAT = "DD ddd";

/**
 * ロケール設定（日本語）
 */
export const LOCALE = "ja-JP";

/**
 * 1日のミリ秒数（24時間）
 */
export const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

/**
 * デフォルト最小スロット時間（ミリ秒）
 */
export const MILLISECONDS_MIN_SLOT_DEFAULT = 0;

/**
 * デフォルト最大スロット時間（ミリ秒）- 24時間
 */
export const MILLISECONDS_MAX_SLOT_DEFAULT = 24 * 60 * 60 * 1000;

/**
 * 1時間のミリ秒数
 */
export const MILLISECONDS_IN_HOUR = 60 * 60 * 1000;

/**
 * メニュー名の表示文字数制限
 */
export const MENU_NAME_LIMIT = 3;

/**
 * 週表示でのメニュー名の表示文字数制限
 */
export const WEEK_MENU_NAME_LIMIT = 10;

/**
 * 顧客名のメニュー表示文字数制限
 */
export const CUSTOMER_NAME_MENU_LIMIT = 4;

/**
 * カレンダーに表示するリソース数の上限（制限なし）
 */
export const CALENDER_RESOURCES_COUNT = 999;

/**
 * 曜日の配列（月曜日から日曜日）
 */
export const WeekDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
